import { render, staticRenderFns } from "./apichart.vue?vue&type=template&id=8a3b3fe6&scoped=true&"
import script from "./apichart.vue?vue&type=script&lang=js&"
export * from "./apichart.vue?vue&type=script&lang=js&"
import style0 from "./apichart.vue?vue&type=style&index=0&id=8a3b3fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3b3fe6",
  null
  
)

export default component.exports